import { apiPublic } from "../../../../../services/Api/Public/apiPublic";

const downloadFile = async (request: Promise<{ data: Blob }>, filename: string): Promise<void> => {
	const response = await request;
	const href = URL.createObjectURL(response.data);

	const link = document.createElement("a");
	link.href = href;
	link.setAttribute("download", filename);
	document.body.appendChild(link);
	link.click();

	document.body.removeChild(link);
	URL.revokeObjectURL(href);
};

export const downloadEReceipt = async (filename: string, orderId?: string): Promise<void> => {
	if (!orderId) {
		return;
	}

	return downloadFile(apiPublic.getEReceipt(orderId), filename);
};

export const downloadInvoice = async (filename: string, invoiceId: string): Promise<void> => {
	return downloadFile(apiPublic.getInvoice(invoiceId), filename);
};
